export default function PlayButton({ isPlaying, handlePlay, handleSpaceKey }) {
    return (
        <div onClick={handlePlay} onKeyUp={handleSpaceKey} tabIndex={0}>
            <svg id='playIcon'width="40" height="46" viewBox="0 0 40 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M38.5437 20.4776C40.4854 21.5987 40.4854 24.4013 38.5437 25.5224L4.36885 45.2532C2.42714 46.3743 -1.06801e-06 44.973 -9.70001e-07 42.7309L7.54926e-07 3.26914C8.52931e-07 1.02704 2.42714 -0.374268 4.36885 0.74678L38.5437 20.4776Z" 
                    fill={isPlaying? "var(--clr_purple)" : "#DFDBCE"}/>
            </svg>
        </div>
  )
}